import { publishTitle } from './PublishStore';

export const updatePublishTitle = (value) => publishTitle.update((oldValue) => value);
